
export const ollamaMcpTestGet = async (url, token) => {
  try {
      const result = await fetch(url + `/ollama-mcp/test-get`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + token,
        },
        // body: formData,
      });

      if (!result.ok) {
        throw new Error("error occured");
      }

      const resData = await result.json();
      console.log(result, resData);
      
      return resData;
  } catch(err) {
    console.log(err);
    throw err;
  }
};

export const getTextVoiceAssistantConfig = async (url, token) => {
  try {
      const result = await fetch(url + `/ollama-mcp-text-voice-assistant/text-voice-assistant-config`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + token,
        },
        // body: formData,
      });

      if (!result.ok) {
        throw new Error("error occured");
      }

      const resData = await result.json();
      console.log(result, resData);
      
      return resData;
  } catch(err) {
    console.log(err);
    throw err;
  }
};